"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SearchBoxComponent = void 0;
var React = _interopRequireWildcard(require("react"));
var _get = _interopRequireDefault(require("lodash/get"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
var _hasChinese = _interopRequireDefault(require("../../utils/hasChinese"));
var _withAppConfig = _interopRequireDefault(require("../HOCs/withAppConfig"));
var _TextInput = _interopRequireDefault(require("../TextInput"));
class SearchBoxComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onChange = value => {
      this.setState({
        value
      });
    };
    /**
     * Handle ENTER key press
     */
    this.onKeyPress = _ref => {
      let {
        key
      } = _ref;
      if (key === 'Enter') this.search();
    };
    this.onBlurHandler = event => {
      let elementWithFocus = (0, _get.default)(event, 'relatedTarget.id', null);

      /* istanbul ignore else */
      if (elementWithFocus === null) {
        elementWithFocus = (0, _get.default)(document, 'activeElement.id', null);
      }

      // button will not receive focus on a Mac (Firefox Only)
      if (elementWithFocus === '') {
        elementWithFocus = (0, _get.default)(event, 'target.id', null) === 'navItem-search' ? 'searchIconButton' : null;
      }
      if (elementWithFocus === 'searchIconButton') {
        event.stopPropagation();
      } else {
        this.props.onClose && this.props.onClose();
      }
    };
    this.isValid = () => {
      const value = this.state.value.trim();
      return (0, _hasChinese.default)(value) || value.length >= this.props.appConfig.search.minCharacters;
    };
    this.search = () => {
      const {
        appConfig,
        onSearch,
        onSearched,
        clearOnSearch
      } = this.props;
      if (!this.isValid()) return;
      const isAnalyticsChannel = (0, _startsWith.default)(window.location.href, appConfig.urls.analytics);
      if (onSearch) {
        onSearch(this.state.value.trim());
      } else {
        const encodedSearchTerm = encodeURIComponent(this.state.value.trim());
        let nextUrl = "".concat(appConfig.urls.search, "?q=").concat(encodedSearchTerm);
        if (isAnalyticsChannel) nextUrl = "".concat(appConfig.urls.analytics, "?s=").concat(encodedSearchTerm);
        window.location.assign(nextUrl);
      }
      if (clearOnSearch) this.setState({
        value: ''
      });
      onSearched(this.state.value);
    };
    this.state = {
      value: props.value
    };
  }

  /* istanbul ignore next */
  componentWillReceiveProps(_ref2) {
    let {
      value
    } = _ref2;
    this.setState({
      value
    });
  }
  render() {
    const isValid = this.isValid();
    return /*#__PURE__*/React.createElement(_TextInput.default, {
      onBlur: this.onBlurHandler,
      id: this.props.id,
      value: this.state.value,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      onClickIcon: this.search,
      isValid: isValid,
      innerRef: this.props.setInputRef,
      tallerInput: this.props.tallerInput,
      icon: "search",
      placeHolderKey: "General.Search",
      iconButtonId: "searchIconButton"
    });
  }
}

// @ts-ignore
exports.SearchBoxComponent = SearchBoxComponent;
SearchBoxComponent.defaultProps = {
  tallerInput: false,
  onSearched: _noop.default,
  value: '',
  clearOnSearch: false
};
var _default = exports.default = (0, _withAppConfig.default)(SearchBoxComponent);